import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListRentalComponent } from './list-rental/list-rental.component';
import { LightboxModule } from 'ngx-lightbox';
import { NgxPaginationModule } from 'ngx-pagination';
import { SidebarModule } from 'ng-sidebar';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MainRentalRoutingModule } from './main-rental-routing.module';
import { MainRentalComponent } from './main-rental.component';
import { AddEditRentalComponent } from './add-edit-rental/add-edit-rental.component';
import { ViewItemComponent } from './view-item/view-item.component';
import { DeleteRentalItemComponent } from './delete-rental-item/delete-rental-item.component';

@NgModule({
  declarations: [ListRentalComponent, MainRentalComponent, AddEditRentalComponent, ViewItemComponent, DeleteRentalItemComponent],
  imports: [
    CommonModule,
    MatToolbarModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCardModule,
    MatInputModule,
    MatDialogModule,
    MatTableModule,
    MatMenuModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    NgMultiSelectDropDownModule,
    SidebarModule.forRoot(),
    NgxPaginationModule,
    LightboxModule,
    MainRentalRoutingModule,
  ],
})
export class MainRentalModule {}
